import { FC } from 'react'
import { CrmRolesEnum } from '@sparling/financial-common'
import { UserAuditLogs } from '../UserAuditLogs'
import { UserTrades } from '../UserTrades'
import { UserTransactions } from '../UserTransactions'
import { UserBalance } from '../UserBalance'
import { UserDetails } from '../UserDetails'
import { UserKYC } from '../UserKYC'
import { UserAccounts } from '../UserAccounts'
import { UserSparlingAccounts } from '../UserSparlingAccounts'

import { IData } from './UserProfileTabs'
import { IntroducerPanel } from '../IntroducerPanel'

interface ComponentProps {
  data?: IData
  startDate?: string | undefined
  endDate?: string | undefined
  currencyFilter?: string | undefined
  userId?: string | undefined
  searchDebounce?: string | undefined
  refreshProfile?: (value: boolean) => void
}

export type componentName = string

export interface ITabList {
  tabLabel: string
  slug: string
  component: FC<ComponentProps>
  roles?: CrmRolesEnum[]
}

export const tabList: ITabList[] = [
  {
    tabLabel: 'User Details',
    slug: 'details',
    component: UserDetails,
  },
  {
    tabLabel: 'KYC',
    slug: 'kyc',
    component: UserKYC,
  },
  {
    tabLabel: 'Audit Logs',
    slug: 'audit-logs',
    component: UserAuditLogs,
  },
  {
    tabLabel: 'Trades',
    slug: 'trades',
    component: UserTrades,
  },
  {
    tabLabel: 'Transactions',
    slug: 'transactions',
    component: UserTransactions,
  },
  {
    tabLabel: 'Balance',
    slug: 'balance',
    component: UserBalance,
  },
  {
    tabLabel: 'Client Accounts',
    slug: 'client-accounts',
    component: UserAccounts,
  },
  {
    tabLabel: 'Sparling Accounts',
    slug: 'sparling-accounts',
    component: UserSparlingAccounts,
  },
  {
    tabLabel: 'Introducer',
    slug: 'introducer',
    component: IntroducerPanel,
  },
]
